import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Ventrata} from 'types'

export const useGetProductApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(
    async (productId: string) => {
      const {data} = await ventrata.get<Ventrata.Product>(`/products/${productId}`, {
        headers: {
          'Octo-Capabilities': 'octo/pricing,octo/content',
        },
      })

      return data
    },
    [ventrata]
  )
}
